
































































import { Component, Vue } from "vue-property-decorator";
import AuthService from "@/services/api/auth.service";
import * as AppNotification from "@/models/notifications/notification";

@Component
export default class RecoverPage extends Vue {
  authService: AuthService = new AuthService();
  isLoading: boolean = false;
  isValid: boolean = false;
  pwd: string = "";
  pwdConfirm: string = "";
  notification: AppNotification.Notification | null = null;

  get Year(): number {
    return new Date().getFullYear();
  }

  async onSubmit() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.authService
      .Recover(this.$route.query.token as string, this.pwd)
      .then(() => {
        this.notification = new AppNotification.Notification(
          "Senha alterada",
          "Já pode efetuar login com a sua nova senha",
          AppNotification.NotificationType.Success
        );
        setTimeout(() => this.$router.replace("/login"), 2000);
      })
      .catch((error: any) => {
        this.notification = AppNotification.Notification.ConvertFromAxios(
          error
        );
      })
      .finally(() => (this.isLoading = false));
  }
}
